// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BookingEventResponse

import { TimingTrigger, BookingRuleMatchMode } from './enums.gen';
import { hydrateBookingEventAction, type BookingEventAction, type BookingEventActionApiResponse } from './bookingEventAction.gen';
import { hydrateBookingRule, type BookingRule, type BookingRuleApiResponse } from './bookingRule.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BookingEventApiResponse = {
	id: string;
	name: string;
	enabled: boolean;
	timingTrigger: TimingTrigger;
	timingOffsetMinutes: number;
	action: BookingEventActionApiResponse;
	rulesConfig: BookingRuleApiResponse[];
	ruleMatchMode: BookingRuleMatchMode;
	archivedAt: string | null;
};

export type BookingEvent = {
	id: string;
	name: string;
	enabled: boolean;
	timingTrigger: TimingTrigger;
	timingOffsetMinutes: number;
	action: BookingEventAction;
	rulesConfig: BookingRule[];
	ruleMatchMode: BookingRuleMatchMode;
	archivedAt: DateTime | null;
};

export function hydrateBookingEvent(data: BookingEventApiResponse): BookingEvent {
	return {
		...data,
		action: hydrateBookingEventAction(data.action),
		rulesConfig: data.rulesConfig.map(hydrateBookingRule),
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}